const email = /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

const phone = /^\d{3}-\d{3}-\d{4}$/;

const number = /^[0-9]*$/;

const date = /(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\d\d/;

export { email, phone, number, date };
